import { useState, useEffect } from 'react'
import { useLookup } from '../../../../../hooks/useLookup'

export function useStates(initialSelected = []) {
  const allStatesRaw = useLookup('state')

  const [states, setStates] = useState([])
  const [allStateOptions, setAllStateOptions] = useState([])
  const [selectedStates, setSelectedStates] = useState(initialSelected)
  const [searchMatches, setSearchMatches] = useState([])

  useEffect(() => {
    if (!allStatesRaw) return
    const options = allStatesRaw.map(s => ({ label: s.name, value: s.name }))
    setStates(allStatesRaw)
    setAllStateOptions(options)
    setSearchMatches(options)
  }, [allStatesRaw])

  const selectAll = () => setSelectedStates(allStateOptions.map(s => s.value))
  const reset = () => setSelectedStates([])
  const select = state => setSelectedStates(prev => [...prev, state])
  const deselect = state => setSelectedStates(prev => prev.filter(s => s !== state))
  const search = str =>
    setSearchMatches(
      allStateOptions.filter(s => s.label.toLowerCase().includes(str.toLowerCase()))
    )
  const getStateObjects = () =>
    selectedStates.map(name => states.find(s => s.name === name)).filter(Boolean)

  return {
    states,
    allStateOptions,
    selectedStates,
    searchMatches,
    selectAll,
    reset,
    select,
    deselect,
    search,
    getStateObjects,
    setSelectedStates,
  }
}
